import React from 'react';
import { Card, CardContent, Divider, Grid, Tooltip, Typography } from '@mui/material';
import { getOrderStatusColor } from 'helpers/utils';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
// import Order from 'types/entities/Order';
// import useOrderWorkunitApi from 'features/Orders/OrderWorkunits/services/useOrderWorkunitApi';

const NewBaseLineOrderWorkunits = (props) => {
  const { order } = props;

  const baseLineOrder = order?.baseLineOrder;
  // const order = useSelector((state) => state.catalogToOrder.order);
  const [t] = useTranslation();
  // const { handleUpdateOrderAction } = useOrderWorkunitApi();
  const userLocale = navigator.language || 'fr-FR';
  const dateFormat = userLocale !== 'en-US' ? 'DD/MM/YYYY' : 'MM/DD/YYYY';
  const formattedStartDate = moment(baseLineOrder?.start_date).format(dateFormat);
  const formattedEndDate = moment(baseLineOrder?.end_date).format(dateFormat);
  const userTimeZone = moment.tz.guess();
  const formatedCreatedDate = moment.utc(baseLineOrder?.created_at).tz(userTimeZone).format(dateFormat);
  const formatedUpdatedDate = moment.utc(baseLineOrder?.updated_at).tz(userTimeZone).format(dateFormat);

  return (
    <Card sx={{ borderLeft: '10px solid', borderColor: getOrderStatusColor(baseLineOrder), mb: 4, mt: 5 }}>
      <CardContent>
        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="space-between"
          sx={{ flexWrap: { lg: 'nowrap' } }}
        >
          {/* <Grid item xs={12} lg="auto" sx={{ position: 'relative', pr: { xs: 0, lg: 4 } }}>
            <Typography variant="h4" color="neutral.main">
              {t('Affair_parameters')}
            </Typography>
            <Divider
              orientation="vertical"
              sx={{
                position: 'absolute',
                height: 'auto',
                top: '10px',
                bottom: '-23px',
                right: 0,
                display: { xs: 'none', lg: 'block' },
                borderColor: 'neutral.main',
              }}
            />
          </Grid> */}
          <Grid item xs={12} lg={2}>
            <Typography>{t('Affair_name')}</Typography>
            <Tooltip
              arrow
              title={
                <>
                  <Typography>{baseLineOrder?.affair_name || ''}</Typography>
                  <Typography>{baseLineOrder?.affair_otp || ''}</Typography>
                </>
              }
            >
              <Typography variant="h6" color="primary.main">
                {baseLineOrder?.affair_name || ''}
              </Typography>
            </Tooltip>
          </Grid>
          <Grid item xs={12} lg={2}>
            <Typography>{t('Client')}</Typography>
            <Tooltip
              title={
                <Typography>
                  {baseLineOrder?.client?.last_name.toLocaleUpperCase() ?? ''} {baseLineOrder?.client?.first_name ?? ''}
                </Typography>
              }
            >
              <Typography variant="h6" color="primary.main">
                {`${baseLineOrder?.client?.last_name.toLocaleUpperCase() ?? ''} ${
                  baseLineOrder?.client?.first_name ?? ''
                }` || ''}
              </Typography>
            </Tooltip>
          </Grid>
          <Grid item xs={12} lg={2}>
            <Typography>{t('Name_spec')}</Typography>
            <Tooltip arrow title={<Typography> {baseLineOrder?.name_spec || ''}</Typography>}>
              <Typography variant="h6" color="primary.main" noWrap>
                {baseLineOrder?.name_spec || ''}
              </Typography>
            </Tooltip>
          </Grid>
          {/* <Grid item xs={12} lg={2}>
            <Typography>{t('Ref_spec')}</Typography>
            <Tooltip arrow title={<Typography> {order?.ref_spec || ''}</Typography>}>
              <Typography variant="h6" color="primary.main" noWrap>
                {order?.ref_spec || ''}
              </Typography>
            </Tooltip>
          </Grid> */}

          {/* <Grid item xs={12} lg={2}>
            <Typography>{t('Price')}</Typography>
            <Tooltip arrow title={<Typography> {order?.amount_price || ''}</Typography>}>
              <Typography variant="h6" color="primary.main" noWrap>
                {order?.amount_price || ''}
              </Typography>
            </Tooltip>
          </Grid> */}
          <Grid item xs={12} lg={2}>
            <Typography>{t('Engagement_date')}</Typography>
            <Tooltip
              title={
                <Typography>
                  {formattedStartDate || ''} - {formattedEndDate || ''}
                </Typography>
              }
            >
              <Typography variant="h6" color="primary.main">
                {formattedStartDate || ''} -{formattedEndDate || ''}
              </Typography>
            </Tooltip>
          </Grid>

          <Grid item xs={12} md={6} lg={1.5}>
            <Tooltip title={formatedCreatedDate}>
              <Typography noWrap sx={{ color: 'primary.main', fontWeight: 500 }}>
                {formatedCreatedDate}
              </Typography>
            </Tooltip>
            <Typography>{t('Created on')}</Typography>
          </Grid>
          <Grid item xs={12} md={6} lg={1.5}>
            <Tooltip title={formatedUpdatedDate}>
              <Typography noWrap sx={{ color: 'primary.main', fontWeight: 500 }}>
                {formatedUpdatedDate}
              </Typography>
            </Tooltip>
            <Typography>{t('Modified on')}</Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};
export default NewBaseLineOrderWorkunits;
